/* -------------------------------------------------------------------------------------------------
 * props
 * -----------------------------------------------------------------------------------------------*/

type SvgComponentProps = {
  width?: number
  height?: number
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const SvgComponent = ({ height = 50, width = 50 }: SvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 50 50"
    fill="none"
  >
    <rect width={50} height={50} className="fill-(--error-circle)" rx={25} />
    <path
      className="fill-(--error-circle-mark) stroke-(--error-circle-mark)"
      fillRule="evenodd"
      d="M16.42 14.83a1.125 1.125 0 0 0-1.59 1.59l8.204 8.205-8.204 8.205a1.125 1.125 0 0 0 1.59 1.59l8.205-8.204 8.205 8.204a1.125 1.125 0 0 0 1.59-1.59l-8.204-8.205 8.204-8.204a1.125 1.125 0 1 0-1.59-1.591l-8.205 8.204-8.204-8.204Z"
      clipRule="evenodd"
    />
  </svg>
)
export { SvgComponent as ErrorCircle }
